enum TaxChangeType {
  ALL = 0,
  FAX = 1,
  GOVDOC = 2,
}

export const allCases = [TaxChangeType.ALL, TaxChangeType.FAX, TaxChangeType.GOVDOC];

export const nameOf = (group: TaxChangeType) => {
  switch (group) {
    case TaxChangeType.ALL:
      return '전체';
    case TaxChangeType.FAX:
      return '팩스';
    case TaxChangeType.GOVDOC:
      return '문서24';
    default:
      return '개별 처리';
  }
};

export const typeOf = (group: TaxChangeType) => {
  switch (group) {
    case TaxChangeType.ALL:
      return undefined;
    case TaxChangeType.FAX:
      return 'fax';
    case TaxChangeType.GOVDOC:
      return 'govdoc';
    default:
      return 'custom';
  }
};

export default TaxChangeType;
